module.exports = __webpack_public_path__ + "img/title-02.80b841fe.png";